export var IconVariant;
(function (IconVariant) {
    IconVariant["AddIcon"] = "addIcon";
    IconVariant["RemoveIcon"] = "removeIcon";
})(IconVariant || (IconVariant = {}));
